import { render, staticRenderFns } from "./CheckboxLegend.vue?vue&type=template&id=5400d293&scoped=true&"
import script from "./CheckboxLegend.vue?vue&type=script&lang=ts&"
export * from "./CheckboxLegend.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxLegend.vue?vue&type=style&index=0&id=5400d293&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5400d293",
  null
  
)

export default component.exports